import React from "react";

const HeroAbout: React.FC = () => {
  const scrollToFounder = () => {
    const founderSection = document.getElementById("founder-section");
    if (founderSection) {
      founderSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url("/technew.png")',
        }}
      />

      <div className="absolute inset-0 bg-gradient-to-br from-black/40 via-transparent to-black/40">
        <div className="absolute inset-0 bg-gradient-to-tr from-black/40 via-transparent to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-tl from-black/40 via-transparent to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-br from-black/40 via-transparent to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-bl from-black/40 via-transparent to-black/30" />
        <div className="absolute inset-0 bg-radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.4) 100%)" />
      </div>

      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 sm:px-6 text-center md:px-20">
        {/* <button className="mb-6 rounded-full border-2 border-white bg-white/10 px-6 py-2 text-sm font-medium text-white backdrop-blur-sm transition-all hover:bg-white/20 md:px-8 md:py-3 md:text-base">
          About Us
        </button> */}

        <h1 className="mb-6 text-3xl sm:text-4xl font-bold text-white md:text-4xl lg:text-6xl xl:text-6xl px-4 sm:px-8 md:px-44">
          Empowering Lives Through Portable Power
        </h1>

        <p className="mx-auto mb-8 max-w-3xl text-sm sm:text-base text-white/90 md:text-lg lg:text-xl px-4 sm:px-8">
          At Devananta, we are dedicated to providing portable power solutions
          that enable a smoother, more resilient lifestyle. Our mission is to
          harness the power of innovation to empower individuals and
          communities, ensuring that you have reliable energy when you need it
          most.
        </p>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 flex flex-col sm:flex-row items-center justify-between px-4 sm:px-8 py-6 space-y-4 sm:space-y-0">
        <div
          className="flex flex-col items-center order-2 sm:order-1 sm:items-center cursor-pointer group"
          onClick={scrollToFounder}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              scrollToFounder();
            }
          }}
        >
          <div className="flex -space-x-3 mb-1 group-hover:scale-105 transition-transform duration-300">
            <div className="h-10 w-10 sm:h-12 sm:w-12 overflow-hidden rounded-full border-2 border-white bg-gray-300">
              <img
                src="/profile1.avif"
                alt="Team member"
                className="h-full w-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = "none";
                }}
              />
            </div>
            <div className="h-10 w-10 sm:h-12 sm:w-12 overflow-hidden rounded-full border-2 border-white bg-gray-400">
              <img
                src="/profile2.avif"
                alt="Team member"
                className="h-full w-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = "none";
                }}
              />
            </div>
            <div className="h-10 w-10 sm:h-12 sm:w-12 overflow-hidden rounded-full border-2 border-white bg-gray-500">
              <img
                src="/profile3.avif"
                alt="Team member"
                className="h-full w-full object-cover"
                onError={(e) => {
                  (e.target as HTMLImageElement).style.display = "none";
                }}
              />
            </div>
          </div>
          <span className="text-xs sm:text-sm font-medium text-white group-hover:text-cyan-300 transition-colors duration-300">
            Our Team
          </span>
        </div>

        <div className="flex items-center justify-center sm:justify-end space-x-3 sm:space-x-4 md:space-x-6 order-1 sm:order-2">
          <div className="hidden sm:flex sm:items-center sm:space-x-3 md:space-x-6">
            {/* Portable - Battery icon */}
            <div className="flex flex-col items-center">
              <div className="mb-1 h-10 w-10 sm:h-12 sm:w-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                <svg
                  className="h-5 w-5 sm:h-6 sm:w-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <span className="text-xs sm:text-sm font-medium text-white">
                Portable
              </span>
            </div>

            {/* Reliable - Check Circle icon */}
            <div className="flex flex-col items-center">
              <div className="mb-1 h-10 w-10 sm:h-12 sm:w-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                <svg
                  className="h-5 w-5 sm:h-6 sm:w-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <span className="text-xs sm:text-sm font-medium text-white">
                Reliable
              </span>
            </div>

            {/* Safe - Shield Check icon */}
            <div className="flex flex-col items-center">
              <div className="mb-1 h-10 w-10 sm:h-12 sm:w-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                <svg
                  className="h-5 w-5 sm:h-6 sm:w-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                  />
                </svg>
              </div>
              <span className="text-xs sm:text-sm font-medium text-white">
                Safe
              </span>
            </div>

            {/* Sustainable - Leaf icon */}
            <div className="flex flex-col items-center">
              <div className="mb-1 h-10 w-10 sm:h-12 sm:w-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                <svg
                  className="h-5 w-5 sm:h-6 sm:w-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 10V3L4 14h7v7l9-11h-7z"
                  />
                </svg>
              </div>
              <span className="text-xs sm:text-sm font-medium text-white">
                Sustainable
              </span>
            </div>
          </div>

          <div className="flex sm:hidden items-center space-x-2">
            {/* Portable - Battery icon (mobile) */}
            <div className="flex flex-col items-center">
              <div className="mb-1 h-8 w-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                <svg
                  className="h-5 w-5 sm:h-6 sm:w-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <span className="text-[10px] font-medium text-white">
                Portable
              </span>
            </div>

            {/* Reliable - Check Circle icon (mobile) */}
            <div className="flex flex-col items-center">
              <div className="mb-1 h-8 w-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                <svg
                  className="h-4 w-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <span className="text-[10px] font-medium text-white">
                Reliable
              </span>
            </div>

            {/* Safe - Shield Check icon (mobile) */}
            <div className="flex flex-col items-center">
              <div className="mb-1 h-8 w-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                <svg
                  className="h-4 w-4 text-white"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
                  />
                </svg>
              </div>
              <span className="text-[10px] font-medium text-white">Safe</span>
            </div>

            {/* Sustainable - Leaf icon (mobile) */}
            <div className="relative group">
              <div className="flex flex-col items-center">
                <div className="mb-1 h-8 w-8 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center">
                  <svg
                    className="h-4 w-4 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M13 10V3L4 14h7v7l9-11h-7z"
                    />
                  </svg>
                </div>
                <span className="text-[10px] font-medium text-white">
                  Sustainable
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroAbout;
